import { SITE } from '@/config/site';

const WHATSAPP_NUMBER = SITE.whatsappNumber;
const WHATSAPP_MESSAGE =
  'Hola%20ACOMA%2C%20quiero%20hablar%20sobre%20un%20proyecto';

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      title="Escríbenos por WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 group"
    >
      <span className="hidden md:inline-block whitespace-nowrap text-sm font-medium text-foreground-950 bg-background-900/90 border border-background-700/60 rounded-full px-4 py-2 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        ¿Hablamos por WhatsApp?
      </span>
      <span
        className="w-14 h-14 flex items-center justify-center rounded-full text-white ring-2 ring-white/10 transition-transform duration-300 group-hover:scale-105 cursor-pointer"
        style={{ backgroundColor: '#25D366' }}
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </span>
    </a>
  );
}